class GoogleAnalyticsEvent {
  constructor(category, action, label, customDimensions = {}) {
    this.eventCategory = category;
    this.eventAction = action;
    this.eventLabel = label;
    this.event = 'GAEvent';

    // Use this property to add custom dimensions that are part of the
    // event you are tracking. These properties will be pushed to the data layer.
    Object.assign(this, customDimensions);
  }
}

export default GoogleAnalyticsEvent;